/**
 * Copia texto para o clipboard com fallback robusto.
 * Tenta navigator.clipboard.writeText (HTTPS / contextos seguros);
 * cai para document.execCommand('copy') via textarea oculta como fallback.
 * Retorna true se sucesso.
 */
export async function copyToClipboard(text) {
  if (!text) return false;
  // Modern API (HTTPS)
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (e) {
      // continua para fallback
    }
  }
  // Fallback: textarea + execCommand
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '0';
    textarea.setAttribute('readonly', '');
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, text.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch (e) {
    return false;
  }
}
